import { SearchParams } from './search-params.modal'

export class SearchDropdown extends SearchParams<string> {
    controlType = 'dropdown'
    options: {key: string, value: string}[] = []

    constructor(options: {} = {}) {
        super(options)
        this.options = options['options'] || ''
    }
}